var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLayout3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 147,
    viewBox: "0 0 183 147",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 182.173,
    height: 147,
    rx: 2,
    fill: "#F4F5F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 19,
    width: 27,
    height: 51,
    rx: 4,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 19,
    width: 27,
    height: 121,
    rx: 4,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 19,
    width: 65,
    height: 121,
    rx: 4,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 28.2793,
    y: 8.54956,
    width: 29.5949,
    height: 5.26132,
    rx: 2,
    fill: "#6D788C"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 60.5054,
    y: 8.54956,
    width: 29.5949,
    height: 5.26132,
    rx: 2,
    fill: "#DADBDD"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 92.0732,
    y: 8.54956,
    width: 29.5949,
    height: 5.26132,
    rx: 2,
    fill: "#DADBDD"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 124.299,
    y: 8.54956,
    width: 29.5949,
    height: 5.26132,
    rx: 2,
    fill: "#DADBDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLayout3);
export default __webpack_public_path__ + "static/media/layout3.3457933d4677ca2ccb0a25a8286e8513.svg";
export { ForwardRef as ReactComponent };